export default {
  getDetail: '/v3/recruit/supplier/intent/detail'
}
